import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, unref as _unref, isRef as _isRef, vModelText as _vModelText, withDirectives as _withDirectives, createVNode as _createVNode, withKeys as _withKeys, vModelSelect as _vModelSelect, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock, Transition as _Transition, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "aprod" }
const _hoisted_2 = {
  class: "aprod__filters",
  "data-tour": "admin-products-status"
}
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "aprod__filter-label" }
const _hoisted_5 = { class: "aprod__filter-count" }
const _hoisted_6 = { class: "sui-card sui-card--flush" }
const _hoisted_7 = {
  class: "sui-toolbar",
  "data-tour": "admin-products-toolbar"
}
const _hoisted_8 = {
  class: "aprod__exposure",
  role: "group",
  "aria-label": "몰 노출 필터",
  "data-tour": "admin-products-exposure"
}
const _hoisted_9 = ["onClick"]
const _hoisted_10 = {
  class: "sui-presets",
  role: "group",
  "aria-label": "최근 변경 기간"
}
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "sui-date" }
const _hoisted_13 = { class: "sui-date" }
const _hoisted_14 = { class: "sui-search" }
const _hoisted_15 = ["disabled"]
const _hoisted_16 = {
  key: 0,
  class: "aprod__error"
}
const _hoisted_17 = {
  key: 1,
  class: "aprod__error"
}
const _hoisted_18 = {
  key: 2,
  class: "sui-table-wrap",
  "data-tour": "admin-products-table"
}
const _hoisted_19 = { class: "sui-table" }
const _hoisted_20 = { class: "sui-prod" }
const _hoisted_21 = ["src", "alt"]
const _hoisted_22 = {
  key: 1,
  class: "aprod__noimg"
}
const _hoisted_23 = ["title", "onClick"]
const _hoisted_24 = { class: "sui-table__sub" }
const _hoisted_25 = { class: "aprod__chips" }
const _hoisted_26 = {
  key: 0,
  class: "aprod__tag aprod__tag--deal"
}
const _hoisted_27 = {
  key: 0,
  class: "aprod__reason"
}
const _hoisted_28 = {
  key: 1,
  class: "sui-table__sub"
}
const _hoisted_29 = {
  key: 2,
  class: "sui-table__sub"
}
const _hoisted_30 = { class: "is-num" }
const _hoisted_31 = { class: "sui-table__strong" }
const _hoisted_32 = { class: "is-num" }
const _hoisted_33 = { class: "is-num" }
const _hoisted_34 = { class: "sui-table__strong" }
const _hoisted_35 = { class: "sui-table__sub aprod__metric-row" }
const _hoisted_36 = ["aria-label", "onClick"]
const _hoisted_37 = ["aria-label", "onClick"]
const _hoisted_38 = { class: "is-center" }
const _hoisted_39 = {
  class: "aprod__stock-cell",
  "data-tour": "admin-products-stock"
}
const _hoisted_40 = ["aria-label", "onClick"]
const _hoisted_41 = { key: 1 }
const _hoisted_42 = { class: "is-center" }
const _hoisted_43 = { class: "aprod__actions" }
const _hoisted_44 = ["disabled", "onClick"]
const _hoisted_45 = ["disabled", "onClick"]
const _hoisted_46 = ["disabled", "onClick"]
const _hoisted_47 = ["disabled", "onClick"]
const _hoisted_48 = {
  key: 3,
  class: "sui-empty"
}
const _hoisted_49 = {
  key: 0,
  class: "sui-toast"
}

import { computed, onMounted, ref, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import AppIcon from '@/components/common/AppIcon.vue'
import ManageProductStorefrontModal from '@/components/manage/ManageProductStorefrontModal.vue'
import ProductStockHistoryModal from '@/components/manage/ProductStockHistoryModal.vue'
import ProductViewsInsightModal from '@/components/manage/ProductViewsInsightModal.vue'
import {
  duplicateAdminProduct,
  setAdminProductStatus,
} from '@/api/admin'
import { useAdminProducts } from '@/composables/useAdminProducts'
import { useListDateRange } from '@/composables/useListDateRange'
import {
  MALL_PRODUCT_STATUS_LABEL,
  isMallLiveStatus,
  mallLiveLabel,
  type MallProductStatus,
  type ServerMallProduct,
} from '@/api/mallProduct'
import { formatWon } from '@/constants/sellerData'
import { marginOf, type MarginBreakdown } from '@/constants/productEditor'
import { saveRequestedProductQueue } from '@/utils/adminProductQueue'

type ExposureKey = '' | 'deal' | 'badge' | 'plain'
type SortKey = 'newest' | 'marginDesc' | 'marginAsc' | 'priceDesc' | 'soldDesc'

const LOW_STOCK_THRESHOLD = 30


export default /*@__PURE__*/_defineComponent({
  __name: 'AdminProductsPage',
  setup(__props) {

const route = useRoute()
const router = useRouter()
const { products, counts, loading, errorMessage, toast, load, notify } = useAdminProducts()
const { fromDate, toDate, preset, presets, applyPreset, onManualDateChange, inRange } = useListDateRange('3m')

const status = ref(normalizeAdminStatus(String(route.query.status ?? '')))
const keyword = ref(String(route.query.keyword || route.query.seller || ''))
const exposure = ref<ExposureKey>(normalizeExposure(route.query.exposure))
const stockLow = ref(String(route.query.stock || '') === 'low')
const sortKey = ref<SortKey>('newest')
const busyCode = ref('')
const actionError = ref('')
const previewCode = ref('')
const previewMallOpen = ref(false)
const previewTab = ref<'detail' | 'review' | 'qna' | 'shipping'>('detail')
const stockHistoryCode = ref('')
const stockHistoryName = ref('')
const viewsInsight = ref<{
  code: string
  name: string
  views: number
  soldCount: number
  mallOpen: boolean
} | null>(null)
function openPreview(
  product: ServerMallProduct,
  tab: 'detail' | 'review' | 'qna' | 'shipping' = 'detail',
) {
  previewTab.value = tab
  previewCode.value = product.code
  previewMallOpen.value = isLive(product)
}

function closePreview() {
  previewCode.value = ''
  previewMallOpen.value = false
  previewTab.value = 'detail'
}

function openViewsInsight(product: ServerMallProduct) {
  viewsInsight.value = {
    code: product.code,
    name: product.name,
    views: product.viewCount,
    soldCount: product.soldCount,
    mallOpen: isLive(product),
  }
}

function openPreviewFromViews() {
  const item = viewsInsight.value
  if (!item) return
  viewsInsight.value = null
  previewTab.value = 'detail'
  previewCode.value = item.code
  previewMallOpen.value = item.mallOpen
}

function openReviewsPreview(product: ServerMallProduct) {
  openPreview(product, 'review')
}

function openStockHistory(product: ServerMallProduct) {
  stockHistoryCode.value = product.code
  stockHistoryName.value = product.name
  syncQuery()
}

function closeStockHistory() {
  stockHistoryCode.value = ''
  stockHistoryName.value = ''
  syncQuery()
}

function onStockUpdated(payload: { code: string; stock: number; status?: string }) {
  const row = products.value.find((item) => item.code === payload.code)
  if (row) {
    row.stock = payload.stock
    if (payload.status) row.status = payload.status as MallProductStatus
  }
  notify(`재고 ${payload.stock.toLocaleString('ko-KR')}개로 반영했습니다.`)
}

const STATUS_TONE: Record<MallProductStatus, string> = {
  DRAFT: 'sui-badge--gray',
  REQUESTED: 'sui-badge--violet',
  SELLING: 'sui-badge--green',
  SOLDOUT: 'sui-badge--amber',
  HIDDEN: 'sui-badge--gray',
  REJECTED: 'sui-badge--red',
}

const statusTabs = computed(() => {
  const total = Object.values(counts.value).reduce((sum, value) => sum + (value ?? 0), 0)
  const requested = counts.value.REQUESTED ?? 0

  return [
    { key: '', label: '전체', count: total, alert: false },
    { key: 'SELLING', label: '판매중', count: counts.value.SELLING ?? 0, alert: false },
    { key: 'REQUESTED', label: '검수요청', count: requested, alert: requested > 0 },
    { key: 'SOLDOUT', label: '품절', count: counts.value.SOLDOUT ?? 0, alert: false },
    { key: 'HIDDEN', label: '숨김', count: counts.value.HIDDEN ?? 0, alert: false },
    { key: 'REJECTED', label: '반려', count: counts.value.REJECTED ?? 0, alert: false },
  ]
})

function normalizeAdminStatus(value: string) {
  return value === 'DRAFT' ? '' : value
}

function statusLabel(value: MallProductStatus) {
  if (value === 'REQUESTED') return '검수요청'
  return MALL_PRODUCT_STATUS_LABEL[value]
}

const datedProducts = computed(() =>
  products.value.filter((product) => {
    const date = product.updatedAt || product.requestedAt || product.reviewedAt || product.createdAt
    if (!date) return true
    return inRange(date)
  }),
)

const lowStockCount = computed(
  () => datedProducts.value.filter((p) => p.stock <= LOW_STOCK_THRESHOLD).length,
)

const exposureChips = computed(() => {
  const list = datedProducts.value
  return [
    { key: '' as ExposureKey, label: '노출 전체', count: list.length },
    { key: 'deal' as ExposureKey, label: '이달의 특가', count: list.filter((p) => p.isDeal).length },
    { key: 'badge' as ExposureKey, label: '배지', count: list.filter((p) => !!p.badge).length },
    {
      key: 'plain' as ExposureKey,
      label: '일반',
      count: list.filter((p) => isLive(p) && !p.isDeal && !p.badge).length,
    },
  ]
})

const visibleProducts = computed(() => {
  let list = datedProducts.value.filter((product) => matchesExposure(product, exposure.value))
  if (stockLow.value) {
    list = list.filter((product) => product.stock <= LOW_STOCK_THRESHOLD)
  }
  const sorted = [...list]
  switch (sortKey.value) {
    case 'marginDesc':
      sorted.sort((a, b) => adminMarginOf(b).platform - adminMarginOf(a).platform)
      break
    case 'marginAsc':
      sorted.sort((a, b) => adminMarginOf(a).platform - adminMarginOf(b).platform)
      break
    case 'priceDesc':
      sorted.sort((a, b) => b.price - a.price)
      break
    case 'soldDesc':
      sorted.sort((a, b) => b.soldCount - a.soldCount)
      break
    default:
      if (stockLow.value) {
        sorted.sort((a, b) => a.stock - b.stock || b.soldCount - a.soldCount)
      } else {
        sorted.sort((a, b) => {
          const da = String(a.updatedAt || a.requestedAt || a.reviewedAt || a.createdAt || '')
          const db = String(b.updatedAt || b.requestedAt || b.reviewedAt || b.createdAt || '')
          return db.localeCompare(da)
        })
      }
  }
  return sorted
})

function normalizeExposure(value: unknown): ExposureKey {
  const key = String(value || '')
  if (key === 'deal' || key === 'badge' || key === 'plain') return key
  return ''
}

function isLive(product: ServerMallProduct): boolean {
  return isMallLiveStatus(product.status)
}

function adminMarginOf(product: ServerMallProduct): MarginBreakdown & { share: number } {
  const base = marginOf({
    price: product.price,
    cost: product.cost,
    marginShare: product.marginShare,
  })
  return {
    ...base,
    share: Math.min(100, Math.max(0, Number(product.marginShare) || 0)),
  }
}

/** 판매가 대비 관리자(함우리) 마진율 */
function adminMarginRate(product: ServerMallProduct): number {
  const price = Math.max(0, product.price || 0)
  if (price <= 0) return 0
  return Math.round((adminMarginOf(product).platform / price) * 1000) / 10
}

function matchesExposure(product: ServerMallProduct, key: ExposureKey): boolean {
  if (!key) return true
  if (key === 'deal') return !!product.isDeal
  if (key === 'badge') return !!product.badge
  if (key === 'plain') return isLive(product) && !product.isDeal && !product.badge
  return true
}

function statusTone(value: MallProductStatus): string {
  return STATUS_TONE[value] ?? 'sui-badge--gray'
}

function badgeTone(badge: string): string {
  if (badge === '특가') return 'aprod__tag--urgent'
  if (badge === '인기' || badge === '베스트') return 'aprod__tag--hot'
  if (badge === 'NEW') return 'aprod__tag--new'
  return 'aprod__tag--badge'
}

function reload() {
  actionError.value = ''
  load({ status: status.value, keyword: keyword.value })
}

function syncQuery() {
  const query: Record<string, string> = {}
  if (status.value) query.status = status.value
  if (keyword.value) query.keyword = keyword.value
  if (exposure.value) query.exposure = exposure.value
  if (stockLow.value) query.stock = 'low'
  if (stockHistoryCode.value) query.code = stockHistoryCode.value
  router.replace({ path: '/admin/products', query })
}

function toggleStockLow() {
  stockLow.value = !stockLow.value
  syncQuery()
}

function setStatus(next: string) {
  status.value = next
  syncQuery()
  reload()
}

function setExposure(next: ExposureKey) {
  exposure.value = next
  syncQuery()
}

function reloadAndSync() {
  syncQuery()
  reload()
}

onMounted(async () => {
  await reload()
  const code = String(route.query.code || '').trim()
  if (code) {
    stockHistoryCode.value = code
    stockHistoryName.value = products.value.find((p) => p.code === code)?.name || ''
  }
})

watch(
  () => [
    route.query.status,
    route.query.keyword,
    route.query.seller,
    route.query.exposure,
    route.query.stock,
    route.query.code,
  ],
  () => {
    const nextStatus = normalizeAdminStatus(String(route.query.status ?? ''))
    const nextKeyword = String(route.query.keyword || route.query.seller || '')
    const nextExposure = normalizeExposure(route.query.exposure)
    const nextStockLow = String(route.query.stock || '') === 'low'
    const nextCode = String(route.query.code || '').trim()
    let needReload = false
    if (nextStatus !== status.value) {
      status.value = nextStatus
      needReload = true
    }
    if (nextKeyword !== keyword.value) {
      keyword.value = nextKeyword
      needReload = true
    }
    if (nextExposure !== exposure.value) {
      exposure.value = nextExposure
    }
    stockLow.value = nextStockLow
    if (nextCode) {
      stockHistoryCode.value = nextCode
      stockHistoryName.value =
        products.value.find((p) => p.code === nextCode)?.name || stockHistoryName.value
    } else {
      stockHistoryCode.value = ''
      stockHistoryName.value = ''
    }
    if (needReload) reload()
  },
)

function onOpenProduct(product: ServerMallProduct) {
  if (product.status !== 'REQUESTED') return
  const codes = visibleProducts.value
    .filter((row) => row.status === 'REQUESTED')
    .map((row) => row.code)
  if (codes.length) saveRequestedProductQueue(codes)
}

async function onDuplicate(product: ServerMallProduct) {
  if (busyCode.value) return
  if (!window.confirm(`'${product.name}'을(를) 복제할까요? 복제본은 임시저장으로 만들어집니다.`)) {
    return
  }
  actionError.value = ''
  busyCode.value = product.code
  try {
    const { product: cloned, message } = await duplicateAdminProduct(product.code)
    notify(message || '상품을 복제했습니다.')
    await load({ status: status.value, keyword: keyword.value })
    router.push(`/admin/products/${cloned.code}`)
  } catch (error) {
    actionError.value = error instanceof Error ? error.message : '상품 복제에 실패했습니다.'
  } finally {
    busyCode.value = ''
  }
}

async function changeStatus(product: ServerMallProduct, next: MallProductStatus, memo: string) {
  actionError.value = ''
  busyCode.value = product.code
  try {
    const result = await setAdminProductStatus(product.code, next, memo)
    notify(result.message || '판매 상태를 바꿨습니다.')
    await load({ status: status.value, keyword: keyword.value })
  } catch (error) {
    actionError.value = error instanceof Error ? error.message : '판매 상태 변경에 실패했습니다.'
  } finally {
    busyCode.value = ''
  }
}

function formatDate(value: string | null): string {
  if (!value) return '-'
  const date = new Date(value)
  return `${date.getFullYear()}.${String(date.getMonth() + 1).padStart(2, '0')}.${String(
    date.getDate(),
  ).padStart(2, '0')}`
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(statusTabs.value, (tab) => {
        return (_openBlock(), _createElementBlock("button", {
          key: tab.key,
          type: "button",
          class: _normalizeClass(["sui-card aprod__filter", { 'is-active': status.value === tab.key, 'is-alert': tab.alert }]),
          onClick: ($event: any) => (setStatus(tab.key))
        }, [
          _createElementVNode("span", _hoisted_4, _toDisplayString(tab.label), 1),
          _createElementVNode("span", _hoisted_5, _toDisplayString(tab.count), 1)
        ], 10, _hoisted_3))
      }), 128))
    ]),
    _createElementVNode("section", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(exposureChips.value, (chip) => {
            return (_openBlock(), _createElementBlock("button", {
              key: chip.key,
              type: "button",
              class: _normalizeClass(["aprod__chip", { 'is-active': exposure.value === chip.key }]),
              onClick: ($event: any) => (setExposure(chip.key))
            }, [
              _createTextVNode(_toDisplayString(chip.label) + " ", 1),
              _createElementVNode("em", null, _toDisplayString(chip.count), 1)
            ], 10, _hoisted_9))
          }), 128)),
          _createElementVNode("button", {
            type: "button",
            class: _normalizeClass(["aprod__chip", { 'is-active': stockLow.value }]),
            "data-tour": "admin-products-stock-low",
            onClick: toggleStockLow
          }, [
            _cache[8] || (_cache[8] = _createTextVNode(" 저재고 ", -1)),
            _createElementVNode("em", null, _toDisplayString(lowStockCount.value), 1)
          ], 2)
        ]),
        _createElementVNode("div", _hoisted_10, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(presets), (item) => {
            return (_openBlock(), _createElementBlock("button", {
              key: item.key,
              type: "button",
              class: _normalizeClass({ 'is-active': _unref(preset) === item.key }),
              onClick: ($event: any) => (_unref(applyPreset)(item.key))
            }, _toDisplayString(item.label), 11, _hoisted_11))
          }), 128))
        ]),
        _createElementVNode("label", _hoisted_12, [
          _cache[9] || (_cache[9] = _createElementVNode("span", null, "시작일", -1)),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(fromDate) ? (fromDate).value = $event : null)),
            type: "date",
            onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(onManualDateChange) && _unref(onManualDateChange)(...args)))
          }, null, 544), [
            [_vModelText, _unref(fromDate)]
          ])
        ]),
        _createElementVNode("label", _hoisted_13, [
          _cache[10] || (_cache[10] = _createElementVNode("span", null, "종료일", -1)),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(toDate) ? (toDate).value = $event : null)),
            type: "date",
            onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_unref(onManualDateChange) && _unref(onManualDateChange)(...args)))
          }, null, 544), [
            [_vModelText, _unref(toDate)]
          ])
        ]),
        _createElementVNode("label", _hoisted_14, [
          _createVNode(AppIcon, {
            icon: "mdi-magnify",
            size: 17
          }),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((keyword).value = $event)),
            type: "search",
            placeholder: "상품명 · 상품코드 · 판매업체 검색",
            onKeydown: _withKeys(reloadAndSync, ["enter"])
          }, null, 544), [
            [
              _vModelText,
              keyword.value,
              void 0,
              { trim: true }
            ]
          ])
        ]),
        _createElementVNode("button", {
          type: "button",
          class: "sui-btn",
          onClick: reloadAndSync
        }, "검색"),
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((sortKey).value = $event)),
          class: "sui-select",
          "aria-label": "정렬",
          "data-tour": "admin-products-sort"
        }, [...(_cache[11] || (_cache[11] = [
          _createStaticVNode("<option value=\"newest\">최근 변경순</option><option value=\"marginDesc\">관리자 마진 높은순</option><option value=\"marginAsc\">관리자 마진 낮은순</option><option value=\"priceDesc\">판매가 높은순</option><option value=\"soldDesc\">판매량 높은순</option>", 5)
        ]))], 512), [
          [_vModelSelect, sortKey.value]
        ]),
        _cache[13] || (_cache[13] = _createElementVNode("span", { class: "sui-toolbar__spacer" }, null, -1)),
        _createElementVNode("button", {
          type: "button",
          class: "sui-btn",
          disabled: _unref(loading) || busyCode.value !== '',
          onClick: reload
        }, [
          _createVNode(AppIcon, {
            icon: "mdi-refresh",
            size: 16
          }),
          _cache[12] || (_cache[12] = _createTextVNode(" 새로고침 ", -1))
        ], 8, _hoisted_15)
      ]),
      (_unref(errorMessage))
        ? (_openBlock(), _createElementBlock("p", _hoisted_16, [
            _createVNode(AppIcon, {
              icon: "mdi-alert-outline",
              size: 16
            }),
            _createTextVNode(" " + _toDisplayString(_unref(errorMessage)), 1)
          ]))
        : (actionError.value)
          ? (_openBlock(), _createElementBlock("p", _hoisted_17, [
              _createVNode(AppIcon, {
                icon: "mdi-alert-outline",
                size: 16
              }),
              _createTextVNode(" " + _toDisplayString(actionError.value), 1)
            ]))
          : _createCommentVNode("", true),
      (visibleProducts.value.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
            _createElementVNode("table", _hoisted_19, [
              _cache[15] || (_cache[15] = _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", null, "상품"),
                  _createElementVNode("th", null, "판매 · 노출"),
                  _createElementVNode("th", { class: "is-num" }, "가격 · 할인"),
                  _createElementVNode("th", { class: "is-num" }, "관리자 마진"),
                  _createElementVNode("th", { class: "is-num" }, "판매 성과"),
                  _createElementVNode("th", { class: "is-center" }, "재고"),
                  _createElementVNode("th", null, "판매업체"),
                  _createElementVNode("th", { class: "is-center" }, "관리")
                ])
              ], -1)),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibleProducts.value, (product) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: product.code
                  }, [
                    _createElementVNode("td", null, [
                      _createElementVNode("span", _hoisted_20, [
                        (product.thumbnail)
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              class: "sui-prod__img",
                              src: product.thumbnail,
                              alt: product.name,
                              loading: "lazy"
                            }, null, 8, _hoisted_21))
                          : (_openBlock(), _createElementBlock("span", _hoisted_22, [
                              _createVNode(AppIcon, {
                                icon: "mdi-image-off-outline",
                                size: 16
                              })
                            ])),
                        _createElementVNode("span", null, [
                          _createElementVNode("button", {
                            type: "button",
                            class: "sui-prod__name-btn",
                            "data-tour": "admin-products-preview",
                            title: `${product.name} 몰 미리보기`,
                            onClick: ($event: any) => (openPreview(product))
                          }, _toDisplayString(product.name), 9, _hoisted_23),
                          _createElementVNode("span", _hoisted_24, _toDisplayString(product.code) + " · " + _toDisplayString(product.category), 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("span", _hoisted_25, [
                        _createElementVNode("span", {
                          class: _normalizeClass(["sui-badge", statusTone(product.status)])
                        }, _toDisplayString(statusLabel(product.status)), 3),
                        _createElementVNode("span", {
                          class: _normalizeClass(["aprod__tag", isLive(product) ? 'aprod__tag--live' : 'aprod__tag--offline']),
                          "data-tour": "admin-products-mall-live"
                        }, _toDisplayString(_unref(mallLiveLabel)(product.status)), 3),
                        (product.isDeal)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_26, "이달의 특가"))
                          : _createCommentVNode("", true),
                        (product.badge)
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 1,
                              class: _normalizeClass(["aprod__tag", badgeTone(product.badge)])
                            }, _toDisplayString(product.badge), 3))
                          : _createCommentVNode("", true)
                      ]),
                      (product.status === 'REJECTED' && product.rejectReason)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_27, _toDisplayString(product.rejectReason), 1))
                        : (product.status === 'REQUESTED')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_28, [
                              _createTextVNode(" 요청 " + _toDisplayString(formatDate(product.requestedAt)) + " ", 1),
                              ((product.requestCount || 0) > 1)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createTextVNode(" · 검수요청 " + _toDisplayString(product.requestCount) + "회 ", 1)
                                  ], 64))
                                : _createCommentVNode("", true)
                            ]))
                          : (_openBlock(), _createElementBlock("span", _hoisted_29, [
                              _createTextVNode(" 변경 " + _toDisplayString(formatDate(product.updatedAt || product.reviewedAt || product.createdAt)) + " ", 1),
                              ((product.requestCount || 0) > 0)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createTextVNode(" · 검수요청 " + _toDisplayString(product.requestCount) + "회 ", 1)
                                  ], 64))
                                : _createCommentVNode("", true)
                            ]))
                    ]),
                    _createElementVNode("td", _hoisted_30, [
                      _createElementVNode("span", _hoisted_31, _toDisplayString(_unref(formatWon)(product.price)) + "원", 1)
                    ]),
                    _createElementVNode("td", _hoisted_32, [
                      _createElementVNode("span", {
                        class: _normalizeClass(["sui-table__strong", { 'is-loss': adminMarginOf(product).negative }])
                      }, _toDisplayString(_unref(formatWon)(adminMarginOf(product).platform)) + "원 ", 3),
                      _createElementVNode("span", {
                        class: _normalizeClass(["sui-table__sub", { 'is-loss': adminMarginOf(product).negative }])
                      }, " 마진율 " + _toDisplayString(adminMarginRate(product)) + "% · 배분 " + _toDisplayString(adminMarginOf(product).share) + "% ", 3)
                    ]),
                    _createElementVNode("td", _hoisted_33, [
                      _createElementVNode("span", _hoisted_34, "판매 " + _toDisplayString(_unref(formatWon)(product.soldCount)), 1),
                      _createElementVNode("span", _hoisted_35, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "aprod__metric-link",
                          "data-tour": "admin-products-views",
                          "aria-label": `${product.name} 조회수 ${product.viewCount} · 전환 보기`,
                          onClick: ($event: any) => (openViewsInsight(product))
                        }, " 조회 " + _toDisplayString(_unref(formatWon)(product.viewCount)), 9, _hoisted_36),
                        _cache[14] || (_cache[14] = _createElementVNode("span", { "aria-hidden": "true" }, "·", -1)),
                        _createElementVNode("button", {
                          type: "button",
                          class: "aprod__metric-link",
                          "data-tour": "admin-products-rating",
                          "aria-label": `${product.name} 평점 ${product.rating.toFixed(1)} · 후기 보기`,
                          onClick: ($event: any) => (openReviewsPreview(product))
                        }, [
                          _createTextVNode(" 리뷰 " + _toDisplayString(_unref(formatWon)(product.reviewCount)) + " ", 1),
                          (product.reviewCount)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createTextVNode(" (" + _toDisplayString(product.rating.toFixed(1)) + ")", 1)
                              ], 64))
                            : _createCommentVNode("", true)
                        ], 8, _hoisted_37)
                      ])
                    ]),
                    _createElementVNode("td", _hoisted_38, [
                      _createElementVNode("div", _hoisted_39, [
                        _createElementVNode("button", {
                          type: "button",
                          class: _normalizeClass(["aprod__stock-link", { 'is-low': product.stock <= 0 }]),
                          "aria-label": `${product.name} 재고 ${product.stock}개 · 이력 보기`,
                          onClick: ($event: any) => (openStockHistory(product))
                        }, _toDisplayString(_unref(formatWon)(product.stock)) + "개 ", 11, _hoisted_40)
                      ])
                    ]),
                    _createElementVNode("td", null, [
                      (product.storeName)
                        ? (_openBlock(), _createBlock(_component_router_link, {
                            key: 0,
                            class: "aprod__store-link",
                            to: {
                    path: '/admin/products',
                    query: {
                      ...(status.value ? { status: status.value } : {}),
                      ...(exposure.value ? { exposure: exposure.value } : {}),
                      keyword: product.storeName,
                    },
                  },
                            onClick: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["stop"]))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(product.storeName), 1)
                            ]),
                            _: 2
                          }, 1032, ["to"]))
                        : (_openBlock(), _createElementBlock("span", _hoisted_41, "—"))
                    ]),
                    _createElementVNode("td", _hoisted_42, [
                      _createElementVNode("div", _hoisted_43, [
                        _createVNode(_component_router_link, {
                          to: `/admin/products/${product.code}`,
                          class: _normalizeClass(["sui-btn sui-btn--sm", product.status === 'REQUESTED' ? 'sui-btn--primary' : '']),
                          onClick: ($event: any) => (onOpenProduct(product))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(product.status === 'REQUESTED' ? '검수하기' : '열기'), 1)
                          ]),
                          _: 2
                        }, 1032, ["to", "class", "onClick"]),
                        (product.status === 'SELLING' || product.status === 'SOLDOUT')
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              type: "button",
                              class: "sui-btn sui-btn--sm",
                              disabled: busyCode.value === product.code,
                              onClick: ($event: any) => (changeStatus(product, 'HIDDEN', '몰에서 내림'))
                            }, " 내리기 ", 8, _hoisted_44))
                          : _createCommentVNode("", true),
                        (product.status === 'HIDDEN')
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 1,
                              type: "button",
                              class: "sui-btn sui-btn--sm sui-btn--primary",
                              disabled: busyCode.value === product.code,
                              onClick: ($event: any) => (changeStatus(product, 'SELLING', '재판매'))
                            }, " 재판매 ", 8, _hoisted_45))
                          : _createCommentVNode("", true),
                        (product.status === 'SELLING' || product.status === 'SOLDOUT' || product.status === 'HIDDEN')
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 2,
                              type: "button",
                              class: "sui-btn sui-btn--sm",
                              disabled: busyCode.value === product.code,
                              onClick: ($event: any) => (changeStatus(product, 'REQUESTED', '재검수로 회수'))
                            }, " 재검수 ", 8, _hoisted_46))
                          : _createCommentVNode("", true),
                        _createElementVNode("button", {
                          type: "button",
                          class: "sui-btn sui-btn--sm",
                          disabled: busyCode.value === product.code,
                          onClick: ($event: any) => (onDuplicate(product))
                        }, " 복제 ", 8, _hoisted_47)
                      ])
                    ])
                  ]))
                }), 128))
              ])
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_48, [
            _createVNode(AppIcon, {
              icon: "mdi-package-variant",
              size: 32
            }),
            _createElementVNode("p", null, _toDisplayString(_unref(loading) ? '불러오는 중입니다…' : '조건에 맞는 상품이 없습니다.'), 1)
          ]))
    ]),
    (previewCode.value)
      ? (_openBlock(), _createBlock(ManageProductStorefrontModal, {
          key: 0,
          code: previewCode.value,
          audience: "admin",
          "mall-open": previewMallOpen.value,
          "initial-tab": previewTab.value,
          onClose: closePreview
        }, null, 8, ["code", "mall-open", "initial-tab"]))
      : _createCommentVNode("", true),
    (viewsInsight.value)
      ? (_openBlock(), _createBlock(ProductViewsInsightModal, {
          key: 1,
          "product-code": viewsInsight.value.code,
          "product-name": viewsInsight.value.name,
          views: viewsInsight.value.views,
          "sold-count": viewsInsight.value.soldCount,
          onClose: _cache[7] || (_cache[7] = ($event: any) => (viewsInsight.value = null)),
          onPreview: openPreviewFromViews
        }, null, 8, ["product-code", "product-name", "views", "sold-count"]))
      : _createCommentVNode("", true),
    (stockHistoryCode.value)
      ? (_openBlock(), _createBlock(ProductStockHistoryModal, {
          key: 2,
          "product-code": stockHistoryCode.value,
          "product-name": stockHistoryName.value,
          audience: "admin",
          onClose: closeStockHistory,
          onUpdated: onStockUpdated
        }, null, 8, ["product-code", "product-name"]))
      : _createCommentVNode("", true),
    _createVNode(_Transition, { name: "sui-toast" }, {
      default: _withCtx(() => [
        (_unref(toast))
          ? (_openBlock(), _createElementBlock("p", _hoisted_49, [
              _createVNode(AppIcon, {
                icon: "mdi-check-circle-outline",
                size: 16
              }),
              _createTextVNode(" " + _toDisplayString(_unref(toast)), 1)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})